require("core-js/modules/es6.date.now");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : (e = e || self).Collapse = t(e.React);
}(this, function (e) {
  "use strict";

  var t = "default" in e ? e["default"] : e;

  function n(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function r() {
    return (r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function o(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function i(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? o(Object(r), !0).forEach(function (t) {
        n(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : o(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function a(e, t) {
    if (null == e) return {};

    var n,
        r,
        o = function (e, t) {
      if (null == e) return {};
      var n,
          r,
          o = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      }

      return o;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
      }
    }

    return o;
  }

  function c(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var n = [],
          r = !0,
          o = !1,
          i = void 0;

      try {
        for (var a, c = e[Symbol.iterator](); !(r = (a = c.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          r || null == c["return"] || c["return"]();
        } finally {
          if (o) throw i;
        }
      }

      return n;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return l(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(n);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return l(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function l(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  function u(e) {
    requestAnimationFrame(function () {
      requestAnimationFrame(e);
    });
  }

  return function (n) {
    var o = n.children,
        l = n.transition,
        s = n.style,
        f = n.render,
        p = n.elementType,
        y = void 0 === p ? "div" : p,
        d = n.isOpen,
        b = n.collapseHeight,
        h = void 0 === b ? "0px" : b,
        g = n.onInit,
        v = n.onChange,
        m = n.className,
        O = void 0 === m ? "collapse-css-transition" : m,
        j = n.addState,
        w = n.noAnim,
        x = n.overflowOnExpanded,
        S = a(n, ["children", "transition", "style", "render", "elementType", "isOpen", "collapseHeight", "onInit", "onChange", "className", "addState", "noAnim", "overflowOnExpanded"]),
        P = function P() {
      return "0px" === h ? "hidden" : "";
    },
        A = c(e.useReducer(function (e) {
      return e + 1;
    }, 0), 2),
        E = (A[0], A[1]),
        D = e.useRef(),
        I = c(e.useState(0), 2),
        T = I[0],
        C = I[1],
        k = e.useRef({
      collapse: d ? "expanded" : "collapsed",
      style: {
        height: d ? "" : h,
        visibility: d ? "" : P()
      }
    }).current;

    e.useEffect(function () {
      T && N(v);
    }, [T]);

    var N = function N(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      e && (e.name, e(i({
        state: k.collapse,
        style: k.style
      }, t)));
    };

    function R() {
      D.current && (k.collapse = "collapsed", k.style = {
        height: h,
        visibility: P()
      }, E(), setTimeout(function () {
        return C(Date.now);
      }, 0));
    }

    function q() {
      D.current && (k.collapse = "expanded", k.style = {
        height: "",
        visibility: ""
      }, E(), setTimeout(function () {
        return C(Date.now);
      }, 0));
    }

    function H() {
      return "".concat(D.current.scrollHeight, "px");
    }

    var F = "expanded" === k.collapse || "expanding" === k.collapse;
    !F && d && function () {
      if (D.current) {
        if (w) return q();
        k.collapse = "expanding", u(function () {
          D.current && "expanding" === k.collapse && (k.style = {
            height: H(),
            visibility: ""
          }, C(Date.now));
        });
      }
    }(), F && !d && function () {
      if (D.current) {
        if (w) return R();
        k.collapse = "collapsing", k.style = {
          height: H(),
          visibility: ""
        }, E(), u(function () {
          D.current && "collapsing" === k.collapse && (k.style = {
            height: h,
            visibility: ""
          }, C(Date.now));
        });
      }
    }();
    var M = i({
      overflow: "expanded" === k.collapse && x ? "" : "hidden",
      transition: l
    }, s, {}, k.style),
        U = y,
        $ = e.useCallback(function (e) {
      e && (D.current = e, N(g, {
        node: e
      }));
    }, [y]),
        z = j ? "".concat(O, " --c-").concat(k.collapse) : O;
    return t.createElement(U, r({
      ref: $,
      style: M,
      onTransitionEnd: function onTransitionEnd(e) {
        var t = e.target,
            n = e.propertyName;

        if (t === D.current && "height" === n) {
          var r = t.style.height;

          switch (k.collapse, k.collapse) {
            case "expanding":
              "" === r || r === h || q();
              break;

            case "collapsing":
              "" === r || r !== h || R();
          }
        }
      },
      className: z
    }, S), "function" == typeof o ? o(k.collapse) : "function" == typeof f ? f(k.collapse) : o);
  };
});